/**
 * Maps a backend provider code to its user-facing display label.
 *
 * Only the visible text differs — the underlying backend/API values
 * ('vrs', 'giacom') are unchanged, so filters, routes and requests keep
 * sending the original codes. See KAN-48 (VRS -> Data) and KAN-49
 * (Giacom -> Crew).
 */
const PROVIDER_LABELS: Record<string, string> = {
  vrs: 'Data',
  giacom: 'Crew',
  // KAN-105: Clarus/Aavora is the integration partner; "Starlink" is what the
  // hardware actually is and what everyone calls it.
  clarus: 'Starlink',
};

export const providerLabel = (provider: string): string =>
  PROVIDER_LABELS[(provider ?? '').toLowerCase()] ?? provider;
